// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/sales-credit-memo-payments',
        component: () =>
            import(/* webpackChunkName: "accounts-receivable.sales-credit-memo-payments" */ '@/pages/[organisation]/receivables/sales-credit-memo-payments/sales-credit-memo-payment/[id].vue'),
        name: 'accounts-receivable.sales-credit-memo-payments.view-sales-credit-memo-payment',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.sales-credit-memo.create-sales-credit-memo-payment',
        },
    },
];
